
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refer/[referralCode]/guest-pass",
      function () {
        return require("private-next-pages/refer/[referralCode]/guest-pass/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refer/[referralCode]/guest-pass"])
      });
    }
  